<template>
	<div class="c-toggle" :class="{ 'c-toggle--disabled': disabled }">
		<div
			class="c-toggle__switch"
			:class="{ 'c-toggle__switch--active': modelValue }"
			@click="toggle"
		>
			<div class="c-toggle__circle"></div>
		</div>
		<label v-if="label" class="c-toggle__label" :class="{ 'c-toggle__label--disabled': disabled }">{{ label }}</label>
	</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CToggle',
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const toggle = () => {
      if (!props.disabled) {
        emit('update:modelValue', !props.modelValue);
      }
    };

    return {
      toggle,
    };
  },
});
</script>

<style scoped lang="scss">
.c-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  &--disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }

  &__label {
    font-size: 14px;
    font-weight: 500;
    color: #212529;
    cursor: pointer;
    user-select: none;

    &--disabled {
      cursor: not-allowed;
      color: #6c757d;
    }
  }

  &__switch {
    position: relative;
    width: 32px;
    height: 16px;
    background-color: #ffffff;
    border: 1px solid #DEE2E6;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;

    &--active {
      background-color: #0D6EFD;
      border-color: #0D6EFD;
    }

    &--disabled {
      cursor: not-allowed;
      background-color: #f8f9fa;
      border-color: #dee2e6;
    }
  }

  &__circle {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 12px;
    height: 12px;
    background-color: #00000040;
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
    transform: translateX(0);

    .c-toggle__switch--active & {
      transform: translateX(16px);
      background-color: #ffffff;
    }

    .c-toggle__switch--disabled & {
      background-color: #adb5bd;
    }
  }

  &:hover {
    .c-toggle__switch {
      border-color: #adb5bd;

      &--active {
        border-color: #0056b3;
        background-color: #0056b3;
      }
    }
  }
}
</style>
